// Mismo algoritmo que src/Validator/Constraints/ValidNifNieValidator.php (backend),
// para dar feedback inmediato en el formulario sin esperar al 422 del servidor.
const DNI_LETTERS = 'TRWAGMYFPDXBNJZSQVHLCKE';
const CIF_CONTROL_LETTERS = 'JABCDEFGHI';
const CIF_LETTER_ONLY_TYPES = ['K', 'P', 'Q', 'S'];
const CIF_DIGIT_ONLY_TYPES = ['A', 'B', 'E', 'H'];

const isValidDniOrNie = (value) => {
  const match = value.match(/^([XYZ]?)(\d{7,8})([A-Z])$/);
  if (!match) return false;

  const [, niePrefix, digits, letter] = match;
  if (niePrefix === '' && digits.length !== 8) return false;
  if (niePrefix !== '' && digits.length !== 7) return false;

  const prefixDigit = { X: '0', Y: '1', Z: '2' }[niePrefix] ?? '';
  const number = parseInt(prefixDigit + digits, 10);

  return DNI_LETTERS[number % 23] === letter;
};

const isValidCif = (value) => {
  const match = value.match(/^([A-HJNPQRSUVW])(\d{7})([0-9A-J])$/);
  if (!match) return false;

  const [, orgType, digits, control] = match;

  let sumEven = 0;
  let sumOdd = 0;
  digits.split('').forEach((char, position) => {
    const digit = parseInt(char, 10);
    if (position % 2 === 0) {
      const doubled = digit * 2;
      sumOdd += doubled >= 10 ? doubled - 9 : doubled;
    } else {
      sumEven += digit;
    }
  });

  const controlDigit = (10 - ((sumEven + sumOdd) % 10)) % 10;
  const controlLetter = CIF_CONTROL_LETTERS[controlDigit];

  if (CIF_LETTER_ONLY_TYPES.includes(orgType)) return control === controlLetter;
  if (CIF_DIGIT_ONLY_TYPES.includes(orgType)) return control === String(controlDigit);

  return control === String(controlDigit) || control === controlLetter;
};

export const isValidNifNieCif = (value) => {
  if (value === null || value === undefined || value === '') return true;

  const normalized = String(value).toUpperCase().replace(/[\s-]/g, '').trim();

  return isValidDniOrNie(normalized) || isValidCif(normalized);
};
